import { createFileRoute } from "@tanstack/react-router";
import FundraisingPledgesKanban from "@/components/Fundraising/Pledges";
import { PageHeader } from "@/components/PageHeader";

function RouteComponent() {
  return (
    <div className="space-y-4">
      <PageHeader
        title="Pledges"
        subtitle="Track investor pledges through the fundraising pipeline."
      />
      <FundraisingPledgesKanban />
    </div>
  );
}

export const Route = createFileRoute("/_authenticated/fundraising/pledges/")({
  component: RouteComponent,
  staticData: { page: "fundraising" },
});
